var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"codics-firm-home-view"},[_c('el-image',{staticStyle:{"height":"100%","width":"100%","position":"relative","float":"left"},attrs:{"src":"https://cdn.bosscaigou.com/PDF%E8%BD%AC%E7%94%BB%E5%86%8C/img/yasuo_24-4-13%20PC%E7%AB%AF%E9%A6%96%E9%A1%B52.webp","fit":"cover"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }